import { render } from "./Edit.vue?vue&type=template&id=94f000a2"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/home/qunxiong/development/zhulu_inc/like_sea_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__